import { render, staticRenderFns } from "./c_labeled_textarea.vue?vue&type=template&id=60fb734e&scoped=true"
import script from "./c_labeled_textarea.vue?vue&type=script&lang=js"
export * from "./c_labeled_textarea.vue?vue&type=script&lang=js"
import style0 from "./c_labeled_textarea.vue?vue&type=style&index=0&id=60fb734e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb734e",
  null
  
)

export default component.exports